<template>
	<section class="container-precadastro">
		<div class="header-table">
			<div class="search-container">
				<ModalDrag
					v-if="modalVisibility"
					:default-data="defaultData"
					:datadrag="columns"
					@ordination="changeOrdination($event)"
					@close="modalVisibility = false"
				/>
				<feather
					class="refreshtable"
					:class="isLoading === true ? 'animation-refresh' : 'stop'"
					type="refresh-cw"
					size="18px"
					@click="!isLoading ? ((selected = {}), $emit('update-table')) : null"
				/>
				<search width="70%" height="35px" @searchtext="(searchTerm = $event), filter()" />
			</div>

			<div v-if="checkedRows.length === 0" class="right-container">
				<div class="select-rows-qt">
					<select
						v-model="rowsperpagechange"
						class="select-container"
						title="Selecionar quantidade de linhas"
						@change="(rowsperpage = rowsperpagechange), $emit('pagelimit', rowsperpagechange)"
					>
						<option :value="10">
							10 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
							Total: {{ totalpages }}
						</option>
						<option :value="30">
							30 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
							Total: {{ totalpages }}
						</option>
						<option :value="50" selected>
							50 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom} /` }}
							Total: {{ totalpages }}
						</option>
						<option :value="100">
							100 Linhas -
							{{ `${userPageStatus} Até ${rowsperpageCustom} / ` }}
							Total: {{ totalpages }}
						</option>
					</select>
				</div>
				<Export :data="data" :filters="filterPrecadastro" />
				<b-dropdown
					aria-role="list"
					:disabled="typeof selected.id === 'undefined'"
					position="is-bottom-left"
				>
					<template #trigger="{ active }">
						<KButton
							slot="trigger"
							height="34px"
							title="Ações"
							:disabled="typeof selected.id === 'undefined'"
							width="unset"
							margin-right="10px"
							font-weight="400"
							:icon="{
								type: `${active ? 'chevron-up' : 'chevron-down'}`,
								size: '18px',
								color: '#8b83ba',
							}"
							font-size="0.8125rem"
							border-radius="0.25rem"
						/>
					</template>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>
				<div class="layout-table" @click="modalVisibility = true">
					Layout
					<feather type="layout" size="18px" class="layout-icon" />
				</div>
				<kfilter
					:filter-visibility="filterVisibility"
					@open-filter="filterVisibility = true"
					@clear="clearFilter"
					@apply="(filterVisibility = !filterVisibility), filter()"
				>
					<template v-slot:container>
						<div class="container-filter">
							<div class="situation-box">
								<b-checkbox v-model="datapagamentocheck" size="is-small" class="checkbox-situation">
									Data de Pagamento
								</b-checkbox>
								<div v-if="datapagamentocheck" class="situation-box-input">
									<feather type="corner-down-right" size="18" class="arrow-indicator" />
									<div class="grouped-situation-input">
										<b-input
											v-model="datapagamento[0]"
											type="date"
											size="is-small"
											class="input-date-picker"
										/>
										<b-input
											v-model="datapagamento[1]"
											type="date"
											size="is-small"
											class="input-date-picker"
										/>
									</div>
								</div>
							</div>
							<div class="situation-pedido-box">
								<b-checkbox
									v-model="situationcheckbox"
									size="is-small"
									class="checkbox-situation-pedido"
								>
									Situação
								</b-checkbox>
								<div v-if="situationcheckbox" class="situation-box-input">
									<feather type="corner-down-right" size="18" class="arrow-indicator" />
									<div class="grouped-situation-pedido-input">
										<treeselect
											v-model="situation"
											class="treeselectcheck"
											:multiple="true"
											:options="options"
										/>
									</div>
								</div>
							</div>
							<div class="situation-pedido-box">
								<b-checkbox
									v-model="statuscheckbox"
									size="is-small"
									class="checkbox-situation-pedido"
								>
									Status
								</b-checkbox>
								<div v-if="statuscheckbox" class="situation-box-input">
									<feather type="corner-down-right" size="18" class="arrow-indicator" />
									<div class="grouped-situation-pedido-input">
										<treeselect
											v-model="status"
											class="treeselectcheck"
											:multiple="true"
											:options="statusOptions"
										/>
									</div>
								</div>
							</div>
							<div class="situation-pagamento-box">
								<b-checkbox
									v-model="sintegrastatuscheckbox"
									size="is-small"
									class="checkbox-situation-pagamento"
								>
									Status Sintegra
								</b-checkbox>
								<div v-if="sintegrastatuscheckbox" class="situation-box-input">
									<feather type="corner-down-right" size="18" class="arrow-indicator" />
									<div class="grouped-situation-pagamento-input">
										<treeselect
											v-model="sintegrastatusInput"
											class="treeselectcheck"
											:multiple="true"
											:options="sintegraOptions"
										/>
									</div>
								</div>
							</div>

							<div class="situation-pagamento-box">
								<b-checkbox
									v-model="motStatuscheckbox"
									size="is-small"
									class="checkbox-situation-pagamento"
								>
									Motivo Arquivamento
								</b-checkbox>
								<div v-if="motStatuscheckbox" class="situation-box-input">
									<feather type="corner-down-right" size="18" class="arrow-indicator" />
									<div class="grouped-situation-pagamento-input">
										<treeselect
											v-model="motStatusInput"
											class="treeselectcheck"
											:multiple="true"
											:options="motStatusOptions"
										/>
									</div>
								</div>
							</div>

							<div class="situation-pagamento-box">
								<b-checkbox
									v-model="estadosCheckbox"
									size="is-small"
									class="checkbox-situation-pagamento"
								>
									UF
								</b-checkbox>
								<div v-if="estadosCheckbox" class="situation-box-input">
									<feather type="corner-down-right" size="18" class="arrow-indicator" />
									<div class="grouped-situation-pagamento-input">
										<treeselect
											v-model="estadosInput"
											class="treeselectcheck"
											:multiple="true"
											:options="estados"
										/>
									</div>
								</div>
							</div>

							<div class="situation-pagamento-box">
								<b-checkbox
									v-model="cidadescheckbox"
									size="is-small"
									class="checkbox-situation-pagamento"
								>
									Cidade
								</b-checkbox>
								<div v-if="cidadescheckbox" class="situation-box-input">
									<feather type="corner-down-right" size="18" class="arrow-indicator" />
									<div class="grouped-situation-pagamento-input">
										<treeselect
											v-model="cidadesinput"
											class="treeselectcheck"
											:load-options="loadOptions"
											:async="true"
											:multiple="true"
											:no-results-text="mensagemErro"
										/>
									</div>
								</div>
							</div>
						</div>
					</template>
				</kfilter>
			</div>
			<div v-if="checkedRows.length > 0" class="right-container">
				<div class="actions-table" @click="multipleActions(1)">
					Aprovar
					<feather type="check-circle" size="18px" class="menu-row-icon check" />
				</div>
				<div class="actions-table" @click="multipleActions(2)">
					Arquivar
					<feather type="archive" size="18px" class="menu-row-icon archive" />
				</div>
				<div class="actions-table" @click="multipleActions(3)">
					Desarquivar
					<feather type="archive" size="18px" class="menu-row-icon archive" />
				</div>
				<div class="actions-table" @click="isModalActive = true">
					Concluir
					<feather type="check" size="18px" class="menu-row-icon check" />
				</div>
			</div>
		</div>
		<b-table
			v-if="data.length > 0"
			ref="table"
			:data="data"
			:paginated="data.length === 0 && isLoading === false ? false : true"
			:opened-detailed="defaultOpenedDetails"
			:loading="isLoading"
			detail-key="id"
			hoverable
			backend-pagination
			:backend-sorting="true"
			:current-page="currentpage"
			:per-page="rowsperpage"
			checkable
			:total="totalpages"
			striped
			focusable
			:selected.sync="selected"
			:show-detail-icon="true"
			aria-next-label="Next page"
			aria-previous-label="Previous page"
			aria-page-label="Page"
			pagination-size="is-small"
			aria-current-label="Current page"
			:sticky-checkbox="true"
			:sticky-header="true"
			:checked-rows.sync="checkedRows"
			@page-change="pageChange($event)"
			@contextmenu="showContext"
			@sort="(name, action) => filter(name, action)"
		>
			<b-table-column v-show="false" v-slot="props">
				<span :ref="'a' + props.row.id" />
			</b-table-column>

			<b-table-column
				v-slot="props"
				:field="columns[0].field"
				:label="columns[0].label"
				header-class="custom-header"
				:sortable="columns[0].sortable"
				:centered="columns[0].centered"
				:visible="columns[0].display"
			>
				<b-dropdown v-if="columns[0].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[0].situacao"
					:data="
						props.row[columns[0].field] === -2
							? 5
							: props.row[columns[0].field] === -1
							? 6
							: props.row[columns[0].field]
					"
				/>

				<h1 v-if="columns[0].normal" class="row-text">
					{{ props.row[columns[0].field] !== null ? props.row[columns[0].field] : '~' }}
				</h1>
				<div v-if="columns[0].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
				<h1 v-if="columns[0].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[0].field]) }}
				</h1>
				<h1 v-if="columns[0].sintegra" class="row-text">
					<Sintegra
						v-if="columns[0].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[0].field],
								receitastatus: props.row[columns[0].secondField],
							})
						"
					/>
				</h1>
			</b-table-column>

			<b-table-column
				v-slot="props"
				:field="columns[1].field"
				:label="columns[1].label"
				:visible="columns[1].display"
				header-class="custom-header"
				numeric
				sortable
				:centered="columns[1].centered"
			>
				<b-dropdown v-if="columns[1].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[1].situacao"
					:data="
						props.row[columns[1].field] === -2
							? 5
							: props.row[columns[1].field] === -1
							? 6
							: props.row[columns[1].field]
					"
				/>

				<h1 v-if="columns[1].normal" class="row-text">
					{{ props.row[columns[1].field] !== null ? props.row[columns[1].field] : '~' }}
				</h1>
				<h1 v-if="columns[1].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[1].field]) }}
				</h1>
				<h1 v-if="columns[1].sintegra" class="row-text">
					<Sintegra
						v-if="columns[1].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[1].field],
								receitastatus: props.row[columns[1].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[1].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>

			<b-table-column
				v-slot="props"
				:field="columns[2].field"
				:label="columns[2].label"
				header-class="custom-header"
				numeric
				:visible="columns[2].display"
				:sortable="columns[2].sortable"
				:centered="columns[2].centered"
			>
				<b-dropdown v-if="columns[2].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[2].situacao"
					:data="
						props.row[columns[2].field] === -2
							? 5
							: props.row[columns[2].field] === -1
							? 6
							: props.row[columns[2].field]
					"
				/>

				<h1 v-if="columns[2].normal" class="row-text">
					{{ props.row[columns[2].field] !== null ? props.row[columns[2].field] : '~' }}
				</h1>
				<h1 v-if="columns[2].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[2].field]) }}
				</h1>
				<h1 v-if="columns[2].sintegra" class="row-text">
					<Sintegra
						v-if="columns[2].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[2].field],
								receitastatus: props.row[columns[2].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[2].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>

			<b-table-column
				v-slot="props"
				:field="columns[3].field"
				:label="columns[3].label"
				header-class="custom-header"
				:sortable="columns[3].sortable"
				:visible="columns[3].display"
				:centered="columns[3].centered"
			>
				<b-dropdown v-if="columns[3].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[3].situacao"
					:data="
						props.row[columns[3].field] === -2
							? 5
							: props.row[columns[3].field] === -1
							? 6
							: props.row[columns[3].field]
					"
				/>

				<h1 v-if="columns[3].normal" class="row-text">
					{{ props.row[columns[3].field] !== null ? props.row[columns[3].field] : '~' }}
				</h1>
				<h1 v-if="columns[3].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[3].field]) }}
				</h1>
				<h1 v-if="columns[3].sintegra" class="row-text">
					<Sintegra
						v-if="columns[3].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[3].field],
								receitastatus: props.row[columns[3].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[3].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>

			<b-table-column
				v-slot="props"
				:field="columns[4].field"
				:label="columns[4].label"
				header-class="custom-header"
				:sortable="columns[4].sortable"
				:centered="columns[4].centered"
				:visible="columns[4].display"
			>
				<b-dropdown v-if="columns[4].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[4].situacao"
					:data="
						props.row[columns[4].field] === -2
							? 5
							: props.row[columns[4].field] === -1
							? 6
							: props.row[columns[4].field]
					"
				/>

				<h1 v-if="columns[4].normal" class="row-text">
					{{ props.row[columns[4].field] !== null ? props.row[columns[4].field] : '~' }}
				</h1>
				<h1 v-if="columns[4].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[4].field]) }}
				</h1>
				<h1 v-if="columns[4].sintegra" class="row-text">
					<Sintegra
						v-if="columns[4].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[4].field],
								receitastatus: props.row[columns[4].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[4].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>
			<b-table-column
				v-slot="props"
				:field="columns[5].field"
				:label="columns[5].label"
				header-class="custom-header"
				:sortable="columns[5].sortable"
				:centered="columns[5].centered"
				:visible="columns[5].display"
			>
				<b-dropdown v-if="columns[5].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[5].situacao"
					:data="
						props.row[columns[5].field] === -2
							? 5
							: props.row[columns[5].field] === -1
							? 6
							: props.row[columns[5].field]
					"
				/>

				<h1 v-if="columns[5].normal" class="row-text">
					{{ props.row[columns[5].field] !== null ? props.row[columns[5].field] : '~' }}
				</h1>
				<h1 v-if="columns[5].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[5].field]) }}
				</h1>
				<h1 v-if="columns[5].sintegra" class="row-text">
					<Sintegra
						v-if="columns[5].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[5].field],
								receitastatus: props.row[columns[5].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[5].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>
			<b-table-column
				v-slot="props"
				:field="columns[6].field"
				:label="columns[6].label"
				:visible="columns[6].display"
				header-class="custom-header"
				:sortable="columns[6].sortable"
				:centered="columns[6].centered"
			>
				<b-dropdown v-if="columns[6].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[6].situacao"
					:data="
						props.row[columns[6].field] === -2
							? 5
							: props.row[columns[6].field] === -1
							? 6
							: props.row[columns[6].field]
					"
				/>

				<h1 v-if="columns[6].normal" class="row-text">
					{{ props.row[columns[6].field] !== null ? props.row[columns[6].field] : '~' }}
				</h1>
				<h1 v-if="columns[6].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[6].field]) }}
				</h1>
				<h1 v-if="columns[6].sintegra" class="row-text">
					<Sintegra
						v-if="columns[6].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[6].field],
								receitastatus: props.row[columns[6].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[6].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>

			<b-table-column
				v-slot="props"
				:field="columns[7].field"
				:label="columns[7].label"
				header-class="custom-header"
				:sortable="columns[7].sortable"
				:centered="columns[7].centered"
				:visible="columns[7].display"
			>
				<b-dropdown v-if="columns[7].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[7].situacao"
					:data="
						props.row[columns[7].field] === -2
							? 5
							: props.row[columns[7].field] === -1
							? 6
							: props.row[columns[7].field]
					"
				/>

				<h1 v-if="columns[7].normal" class="row-text">
					{{ props.row[columns[7].field] !== null ? props.row[columns[7].field] : '~' }}
				</h1>
				<h1 v-if="columns[7].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[7].field]) }}
				</h1>
				<h1 v-if="columns[7].sintegra" class="row-text">
					<Sintegra
						v-if="columns[7].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[7].field],
								receitastatus: props.row[columns[7].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[7].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>

			<b-table-column
				v-slot="props"
				:visible="columns[8].display"
				:field="columns[8].field"
				:label="columns[8].label"
				header-class="custom-header"
				:sortable="columns[8].sortable"
				:centered="columns[8].centered"
			>
				<b-dropdown v-if="columns[8].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[8].situacao"
					:data="
						props.row[columns[8].field] === -2
							? 5
							: props.row[columns[8].field] === -1
							? 6
							: props.row[columns[8].field]
					"
				/>

				<h1 v-if="columns[8].normal" class="row-text">
					{{ props.row[columns[8].field] !== null ? props.row[columns[8].field] : '~' }}
				</h1>
				<h1 v-if="columns[8].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[8].field]) }}
				</h1>
				<h1 v-if="columns[8].sintegra" class="row-text">
					<Sintegra
						v-if="columns[8].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[8].field],
								receitastatus: props.row[columns[8].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[8].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>

			<b-table-column
				v-slot="props"
				:visible="columns[9].display"
				:field="columns[9].field"
				:label="columns[9].label"
				header-class="custom-header"
				:sortable="columns[9].sortable"
				:centered="columns[9].centered"
			>
				<b-dropdown v-if="columns[9].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[9].situacao"
					:data="
						props.row[columns[9].field] === -2
							? 5
							: props.row[columns[9].field] === -1
							? 6
							: props.row[columns[9].field]
					"
				/>

				<h1 v-if="columns[9].normal" class="row-text">
					{{ props.row[columns[9].field] !== null ? props.row[columns[9].field] : '~' }}
				</h1>
				<h1 v-if="columns[9].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[9].field]) }}
				</h1>
				<h1 v-if="columns[9].sintegra" class="row-text">
					<Sintegra
						v-if="columns[9].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[9].field],
								receitastatus: props.row[columns[9].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[9].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>

			<b-table-column
				v-slot="props"
				:field="columns[10].field"
				:label="columns[10].label"
				:visible="columns[10].display"
				header-class="custom-header"
				:sortable="columns[10].sortable"
				:centered="columns[10].centered"
			>
				<b-dropdown v-if="columns[10].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[10].situacao"
					:data="
						props.row[columns[10].field] === -2
							? 5
							: props.row[columns[10].field] === -1
							? 6
							: props.row[columns[10].field]
					"
				/>

				<h1 v-if="columns[10].normal" class="row-text">
					{{ props.row[columns[10].field] !== null ? props.row[columns[10].field] : '~' }}
				</h1>
				<h1 v-if="columns[10].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[10].field]) }}
				</h1>
				<h1 v-if="columns[10].sintegra" class="row-text">
					<Sintegra
						v-if="columns[10].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[10].field],
								receitastatus: props.row[columns[10].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[10].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>

			<b-table-column
				v-slot="props"
				:field="columns[11].field"
				:label="columns[11].label"
				header-class="custom-header"
				:visible="columns[11].display"
				:sortable="columns[11].sortable"
				:centered="columns[11].centered"
			>
				<b-dropdown v-if="columns[11].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[11].situacao"
					:data="
						props.row[columns[11].field] === -2
							? 5
							: props.row[columns[11].field] === -1
							? 6
							: props.row[columns[11].field]
					"
				/>

				<h1 v-if="columns[11].normal" class="row-text">
					{{ props.row[columns[11].field] !== null ? props.row[columns[11].field] : '~' }}
				</h1>
				<h1 v-if="columns[11].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[11].field]) }}
				</h1>
				<h1 v-if="columns[11].sintegra" class="row-text">
					<Sintegra
						v-if="columns[11].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[11].field],
								receitastatus: props.row[columns[11].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[11].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>

			<b-table-column
				v-slot="props"
				:field="columns[12].field"
				:label="columns[12].label"
				:visible="columns[12].display"
				header-class="custom-header"
				:sortable="columns[12].sortable"
				:centered="columns[12].centered"
			>
				<b-dropdown v-if="columns[12].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[12].situacao"
					:data="
						props.row[columns[12].field] === -2
							? 5
							: props.row[columns[12].field] === -1
							? 6
							: props.row[columns[12].field]
					"
				/>

				<h1 v-if="columns[12].normal" class="row-text">
					{{ props.row[columns[12].field] !== null ? props.row[columns[12].field] : '~' }}
				</h1>
				<h1 v-if="columns[12].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[12].field]) }}
				</h1>
				<h1 v-if="columns[12].sintegra" class="row-text">
					<Sintegra
						v-if="columns[12].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[12].field],
								receitastatus: props.row[columns[12].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[12].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>

			<b-table-column
				v-slot="props"
				:field="columns[13].field"
				:label="columns[13].label"
				header-class="custom-header"
				:sortable="columns[13].sortable"
				:centered="columns[13].centered"
				:visible="columns[13].display"
			>
				<b-dropdown v-if="columns[13].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[13].situacao"
					:data="
						props.row[columns[13].field] === -2
							? 5
							: props.row[columns[13].field] === -1
							? 6
							: props.row[columns[13].field]
					"
				/>

				<h1 v-if="columns[13].normal" class="row-text">
					{{ props.row[columns[13].field] !== null ? props.row[columns[13].field] : '~' }}
				</h1>
				<h1 v-if="columns[13].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[13].field]) }}
				</h1>
				<h1 v-if="columns[13].sintegra" class="row-text">
					<Sintegra
						v-if="columns[13].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[13].field],
								receitastatus: props.row[columns[13].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[13].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>
			<b-table-column
				v-slot="props"
				:field="columns[14].field"
				:label="columns[14].label"
				header-class="custom-header"
				:sortable="columns[14].sortable"
				:centered="columns[14].centered"
				:visible="columns[14].display"
			>
				<b-dropdown v-if="columns[14].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[14].situacao"
					:data="
						props.row[columns[14].field] === -2
							? 5
							: props.row[columns[14].field] === -1
							? 6
							: props.row[columns[14].field]
					"
				/>

				<h1 v-if="columns[14].normal" class="row-text">
					{{ props.row[columns[14].field] !== null ? props.row[columns[14].field] : '~' }}
				</h1>
				<h1 v-if="columns[14].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[14].field]) }}
				</h1>
				<h1 v-if="columns[14].sintegra" class="row-text">
					<Sintegra
						v-if="columns[14].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[14].field],
								receitastatus: props.row[columns[14].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[14].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>

			<b-table-column
				v-slot="props"
				:visible="columns[15].display"
				:field="columns[15].field"
				:label="columns[15].label"
				header-class="custom-header"
				:sortable="columns[15].sortable"
				:centered="columns[15].centered"
			>
				<b-dropdown v-if="columns[15].isacoes" aria-role="list">
					<h1 slot="trigger" class="row-actions-circles">
						<div class="circle" />
						<div class="circle" />
						<div class="circle" />
					</h1>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao !== 0 ? (selected.situacao !== -2 ? true : false) : false"
					>
						<div class="menu-row-option" @click="verifystatus({ selected: selected, action: 1 })">
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Aprovar</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item aria-role="listitem" :disabled="selected.situacao !== 3">
						<div
							class="menu-row-option"
							@click="
								selected.situacao === 3
									? $emit('concluir', { selected: selected, multiple: false })
									: null
							"
						>
							<feather class="menu-row-icon check" type="check" size="16" />
							<h1>Concluir</h1>
						</div>
					</b-dropdown-item>

					<b-dropdown-item
						aria-role="listitem"
						:disabled="selected.situacao === 1 || selected.situacao === 2"
					>
						<div
							class="menu-row-option"
							@click.prevent="
								selected.situacao !== 1 && selected.situacao !== 2
									? $router.push(`/precadastro/edit/` + selected.id)
									: ''
							"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Editar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item
						aria-role="listitem"
						:disabled="
							selected.situacao !== 0 &&
							selected.situacao !== -1 &&
							selected.situacao !== 2 &&
							selected.situacao !== 3 &&
							selected.status !== 2
						"
					>
						<div
							v-if="selected.status !== 2"
							class="menu-row-option"
							@click.prevent="
								archive({ id: [selected.id], motivo: 2 }, selected.situacao, selected.status !== 2)
							"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Arquivar</h1>
						</div>
						<div
							v-if="selected.status === 2"
							class="menu-row-option"
							@click="unarchive(selected.id)"
						>
							<feather class="menu-row-icon archive" type="archive" size="16" />
							<h1>Desarquivar</h1>
						</div>
					</b-dropdown-item>
					<b-dropdown-item aria-role="listitem">
						<div
							class="menu-row-option"
							@click.prevent="$router.push(`/precadastro/details/` + selected.id)"
						>
							<feather class="menu-row-icon check" type="edit" size="16" />
							<h1>Ver Detalhes</h1>
						</div>
					</b-dropdown-item>
				</b-dropdown>

				<Status
					v-if="columns[15].situacao"
					:data="
						props.row[columns[15].field] === -2
							? 5
							: props.row[columns[15].field] === -1
							? 6
							: props.row[columns[15].field]
					"
				/>

				<h1 v-if="columns[15].normal" class="row-text">
					{{ props.row[columns[15].field] !== null ? props.row[columns[15].field] : '~' }}
				</h1>
				<h1 v-if="columns[15].status" class="row-text">
					{{ verifyStatusRow(props.row[columns[15].field]) }}
				</h1>
				<h1 v-if="columns[15].sintegra" class="row-text">
					<Sintegra
						v-if="columns[15].field === 'sintegrastatus'"
						:data="
							getSintegraStatus({
								sintegrastatus: props.row[columns[15].field],
								receitastatus: props.row[columns[15].secondField],
							})
						"
					/>
				</h1>
				<div v-if="columns[15].date">
					<h1 class="row-text">
						{{ dateTimetoDate(props.row.created_at) }}
					</h1>
					<h2 class="table-subtitle">as {{ dateTimetoTime(props.row.created_at) }}</h2>
				</div>
			</b-table-column>
		</b-table>
		<OptModal
			v-if="showModalArquivar"
			@close="showModalArquivar = false"
			@select="archiveModal($event)"
		/>
		<Empty v-if="data.length === 0 && isLoading === false" />
		<k-modal
			message="Você está prestes a concluir estes itens"
			:active="isModalActive"
			width="500px"
			down-button="Concluir"
			@close="isModalActive = $event"
			@apply="concludeRegister()"
		>
			<div slot="box" class="box">
				<div class="box-container">
					<div
						v-for="(item, index) of checkedRows"
						:key="index"
						class="row-item"
						:class="item.situacao != 3 ? 'inactive' : 'active'"
						:title="
							item.situacao != 3
								? 'Não é permitido concluir o cadastro com essa situação'
								: 'Liberado para concluir'
						"
					>
						<span class="row-item-text"> #{{ item.id }}</span>
						<span class="row-item-text">
							{{ item.nomerazao }}
							<feather
								type="trash"
								class="icon-close"
								size="11px"
								@click="removeCheckedItem(item)"
							/>
						</span>
					</div>
				</div>
			</div>
		</k-modal>
	</section>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import global from '../../../mixins/global';
import search from '../search/index';
import kfilter from '../filter/custom';
import Status from '../tags/Status';
import Sintegra from '../tags/sintegra';
import OptModal from '../modal/cadoptions';
import * as ecAxios from '../../../util/ecAxios';
import Empty from '../empty/index';
import ModalDrag from '../modal/dragable';
import kModal from '../modal/kmodal';
import KButton from '../buttons/Default';
import Export from '../miscellaneous/exportpcdt';

export default {
	components: {
		ModalDrag,
		search,
		kfilter,
		Export,
		kModal,
		Status,
		Sintegra,
		OptModal,
		Treeselect,
		Empty,
		KButton,
	},
	mixins: [global],
	props: {
		mycolumns: {
			type: Array,
			default: () => [],
		},
		data: {
			type: Array,
			default: () => [],
		},
		isLoading: {
			type: Boolean,
			default: true,
		},
		currentpage: {
			type: Number,
			default: 1,
		},
		totalpages: {
			type: Number,
			default: 0,
		},
	},
	data() {
		return {
			mensagemErro: 'Digite no mínimo 3 caracteres.',
			copyField: null,
			isModalActive: false,
			defaultData: this.mycolumns,
			columns: this.mycolumns ? this.mycolumns : [],
			modalVisibility: false,
			rowsperpageCustom: 0,
			motStatusOptions: [],
			motStatusInput: [],
			motStatusData: null,
			motStatuscheckbox: false,
			rowsperpage: 50,
			rowsperpagechange: 50,
			userPageStatus: 50,
			checkedRows: [],
			showModalArquivar: false,
			orderby: null,
			direction: null,
			estados: [],
			estadosData: [],
			estadosCheckbox: false,
			estadosInput: [],
			statusOptions: [
				{
					label: 'Inativo',
					id: 0,
				},
				{
					label: 'Ativo',
					id: 1,
				},
				{
					label: 'Arquivado',
					id: 2,
				},
			],
			status: [1],
			statuscheckbox: true,
			options: [
				{
					id: 0,
					label: 'Recebido',
				},
				{
					id: 1,
					label: 'Aprovado',
				},
				{
					id: 2,
					label: 'Integrado',
				},
				{
					id: 3,
					label: 'Integrado',
				},
				{
					id: 4,
					label: 'Concluído',
				},
				{
					id: -2,
					label: 'Análise',
				},
				{
					id: -1,
					label: 'Digitando',
				},
			],
			situationcheckbox: false,
			situationcondpagamento: false,
			situationpagamento: false,
			situation: [],
			cidadesinput: [],
			cidadescheckbox: false,
			cidadeData: [],
			situacao: [],
			lastpage: 0,
			datapagamentocheck: false,
			datapagamento: ['', ''],
			archivedata: {},
			dateRange: {},
			sintegrastatusInput: [],
			sintegrastatus: [],
			searchTerm: '',
			sintegrastatuscheckbox: false,
			sintegraOptions: [
				{
					id: 0,
					label: 'Bloqueado',
				},
				{
					id: 1,
					label: 'Liberado',
				},
			],
			filterVisibility: false,
			defaultOpenedDetails: [1],
			selected: {},
			selectaction: '',
			cidades: [],
			lastSelected: [],
			selectedMultiples: [],
			isMultipleCombinations: false,
		};
	},
	computed: {
		filterPrecadastro() {
			const precadastrofilter = JSON.parse(localStorage.getItem('filters-precadastro'));
			return precadastrofilter;
		},
	},
	watch: {
		rowsperpagechange() {
			this.pageChange(this.lastpage);
		},
		data() {
			this.checkedRows = [];
		},
		selected(e) {
			// Mudar para nexttick.
			setTimeout(() => {
				this.selectRowTable(e);
				this.focustTable(`a${e.id}`);
			}, 0.5);
		},
	},
	created() {
		this.getAllMotStatus();
		const store = JSON.parse(localStorage.getItem('filters-precadastro'));
		if (store) {
			this.getStore();
		}
		this.getDistritos();
		this.pageChange(1);
		document.addEventListener('keyup', this.keyPressed);
		this.filter();
	},
	methods: {
		loadOptions({ searchQuery, callback }) {
			if (searchQuery.length < 3) {
				this.mensagemErro = 'Digite no mínimo 3 caracteres.';
				callback(null, []);
			} else {
				this.mensagemErro = 'Nenhum Resultado Encontrado.';
				const cidadesFiltradas = this.cidades.filter((cidade) => cidade.label && cidade.label.toLowerCase().includes(searchQuery.toLowerCase()));
				callback(null, cidadesFiltradas);
			}
		},
		async copyToClipboard(text) {
			let response = false;
			navigator.clipboard.writeText(text).then(
				() => {
					response = true;
				},
				() => {
					response = false;
				}
			);
			return response;
		},
		showContext(row, context) {
			context.preventDefault();
			if (this.copyField) {
				const response = this.copyToClipboard(row[this.copyField]);

				if (response) {
					this.$buefy.toast.open({
						message: `${this.copyField.toUpperCase()} copiado 😃`,
						type: 'is-success',
					});
				} else {
					this.$buefy.toast.open({
						message: 'Falha ao copiar 😢',
						type: 'is-danger',
					});
				}
			}
			this.copyField = null;
		},
		uniqBy(a, key) {
			const seen = new Set();
			return a.filter((item) => {
				const k = key(item);
				return seen.has(k) ? false : seen.add(k);
			});
		},
		getStore() {
			const store = JSON.parse(localStorage.getItem('filters-precadastro'));
			const {
				cidadeData,
				cidadescheckbox,
				cidadesinput,
				datapagamento,
				datapagamentocheck,
				dateRange,
				estadosCheckbox,
				motStatusInput,
				motStatuscheckbox,
				motStatusData,
				estadosData,
				estadosInput,
				sintegrastatus,
				sintegrastatusInput,
				sintegrastatuscheckbox,
				situacao,
				situation,
				situationcheckbox,
				status,
				statuscheckbox,
			} = store;

			this.motStatusInput = motStatusInput;
			this.motStatuscheckbox = motStatuscheckbox;
			this.motStatusData = motStatusData;
			this.cidadeData = cidadeData;
			this.cidadescheckbox = cidadescheckbox;
			this.cidadesinput = cidadesinput;
			this.datapagamento = datapagamento;
			this.datapagamentocheck = datapagamentocheck;
			this.dateRange = dateRange;
			this.estadosCheckbox = estadosCheckbox;
			this.estadosData = estadosData;
			this.estadosInput = estadosInput;
			this.sintegrastatus = sintegrastatus;
			this.sintegrastatusInput = sintegrastatusInput;
			this.sintegrastatuscheckbox = sintegrastatuscheckbox;
			this.situacao = situacao;
			this.situation = situation;
			this.situationcheckbox = situationcheckbox;
			if (status.length > 0) {
				this.status = status;
				this.statuscheckbox = statuscheckbox;
			} else {
				this.status = [1];
				this.statuscheckbox = true;
			}
		},
		concludeRegister() {
			const selectedIds = [];
			this.checkedRows.forEach((element) => {
				if (element.situacao === 3) {
					selectedIds.push(element.id);
				} else {
					this.removeCheckedItem(element);
				}
			});

			this.$emit('multiple-finish', {
				ids: selectedIds,
			});

			this.isModalActive = false;
		},
		changeOrdination(columnsOrd) {
			localStorage.setItem('columns', JSON.stringify(columnsOrd));
			this.columns = JSON.parse(localStorage.getItem('columns'));
			this.modalVisibility = false;
		},
		keyPressed(keypress) {
			this.selectaction = null;
			if (keypress.shiftKey && keypress.keyCode === 40) {
				this.selectaction = 'downselect';
			}
			if (keypress.shiftKey && keypress.keyCode === 38) {
				this.selectaction = 'upselect';
			}
			if (keypress.altKey && keypress.keyCode === 67) {
				this.copyField = 'cnpj';
			}
			if (keypress.altKey && keypress.keyCode === 78) {
				this.copyField = 'nomerazao';
			}
		},
		removeCheckedItem(item) {
			const index = this.checkedRows.findIndex((row) => row === item);
			this.checkedRows.splice(index, 1);
			if (this.checkedRows.length === 0) {
				this.isModalActive = false;
			}
		},
		parseIndexes() {
			const ret = [];
			const that = this;
			this.checkedRows.forEach((index) => {
				ret.push(that.rows[index].id);
			});
			return ret;
		},
		multipleActions(action) {
			if (action === 1) {
				const idsRows = [];
				this.checkedRows.map((item) => {
					if (item.situacao !== 0 && item.situacao !== -2) {
						this.$buefy.notification.open({
							message: `${item.nomerazao} não pode ser aprovado!`,
							type: 'is-warning',
						});
					} else {
						idsRows.push(item.id);
					}
					return null;
				});
				this.$emit('multiple-aprove', idsRows);
			}
			if (action === 2) {
				const allowedIds = this.checkedRows
					.filter((item) => {
						if (
							item.situacao !== -1 &&
							item.situacao !== 0 &&
							item.situacao !== 2 &&
							item.situacao !== 3 &&
							item.status === 2
						) {
							this.$buefy.notification.open({
								message: `${item.nomerazao} não pode ser arquivado!`,
								type: 'is-warning',
							});
							return false;
						}

						return true;
					})
					.map((item) => item.id);

				this.archive(allowedIds);
			}

			if (action === 3) {
				this.checkedRows.map((item) => {
					if (item.status !== 2) {
						this.$buefy.notification.open({
							message: `${item.nomerazao} não pode ser desarquivado!`,
							type: 'is-warning',
						});
					} else if (item.status === 2) {
						this.checkedRows.map((selected) => this.unarchive(selected.id));
					}
					return null;
				});
			}
		},
		selectRowTable(event) {
			switch (this.selectaction) {
				case 'upselect':
					this.upselectAction(event);
					break;
				case 'downselect':
					this.upselectAction(event);

					break;

				case null:
					this.checkedRows = [event];

					break;

				default:
					/* this.checkedRows = [event]; */
					break;
			}

			this.selectaction = undefined; // gambiara hein
		},
		filterStore() {
			const event = JSON.parse(localStorage.getItem('filters-precadastro'));
			if (event) {
				this.dateRange = event.dateRange;
				this.situacao = event.situacao;
				this.sintegrastatus = event.sintegrastatus;
				this.cidadeData = event.cidadeData;
				this.estadosData = event.estadosData;
				this.datapagamento = event.datapagamento;
				this.datapagamentocheck = event.datapagamentocheck;
				this.situation = event.situation;
				this.situationcheckbox = event.situationcheckbox;
				this.status = event.status;
				this.statuscheckbox = event.statuscheckbox;
				this.sintegrastatusInput = event.sintegrastatusInput;
				this.sintegrastatuscheckbox = event.sintegrastatuscheckbox;
				this.cidadescheckbox = event.cidadescheckbox;
				this.cidadesinput = event.cidadesinput;
				this.estadosCheckbox = event.estadosCheckbox;
				this.estadosInput = event.estadosInput;
			}
		},
		upselectAction(event) {
			const arrIndex = this.selectedMultiples.findIndex((element) => element.id === event.id);
			if (this.checkedRows.length > 1 && arrIndex !== -1) {
				this.checkedRows.splice(arrIndex);
			} else {
				this.checkedRows.push(event);
			}
		},
		focustTable(refId = 'a139') {
			this.$refs[refId].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
		},
		pageChange(pagenumber) {
			const offset = pagenumber * this.rowsperpagechange - this.rowsperpagechange;
			this.$emit('pagechange', { limit: this.rowsperpagechange, offset, pagenumber });
			this.lastpage = pagenumber;
			this.rowsperpageCustom = pagenumber * this.rowsperpagechange + 1;
			this.userPageStatus = this.rowsperpageCustom - this.rowsperpagechange;
		},

		clearFilter() {
			this.dateRange = [];
			this.situacao = [];
			this.sintegrastatus = [];
			this.cidadeData = [];
			this.estadosData = [];
			this.datapagamento = ['', ''];
			this.datapagamentocheck = false;
			this.situation = [];
			this.situationcheckbox = false;
			this.sintegrastatusInput = [];
			this.sintegrastatuscheckbox = false;
			this.cidadescheckbox = false;
			this.cidadesinput = [];
			this.estadosCheckbox = false;
			this.estadosInput = [];
			this.motStatusData = [];
			this.motStatusInput = [];
			this.motStatuscheckbox = false;
			this.filter();
		},

		filter(orderby = null, direction = null) {
			this.dateRange = [];
			this.situacao = [];
			this.sintegrastatus = [];
			this.cidadeData = [];
			this.estadosData = [];
			this.motStatusData = [];
			if (orderby && direction) {
				this.orderby = orderby;
				this.direction = direction;
			}
			if (this.datapagamentocheck === true) {
				if (this.datapagamento[0] !== '' && this.datapagamento[1] !== '') {
					this.dateRange = {
						startDate: this.datapagamento[0],
						endDate: this.datapagamento[1],
					};
				}
			}
			if (this.situationcheckbox === true) {
				if (this.situation.length > 0) {
					this.situacao = this.situation;
				}
			}
			if (this.motStatuscheckbox === true && this.motStatusInput.length > 0) {
				this.motStatusData = this.motStatusInput;
			}
			if (this.sintegrastatuscheckbox === true && this.sintegrastatusInput.length > 0) {
				this.sintegrastatus = this.sintegrastatusInput;
			}
			if (this.cidadescheckbox && this.cidadesinput.length > 0) {
				this.cidadeData = this.cidadesinput;
			}
			if (this.estadosCheckbox === true && this.estadosInput.length > 0) {
				this.estadosData = this.estadosInput;
			}

			const filterStore = {
				dateRange: this.dateRange,
				situacao: this.situacao,
				sintegrastatus: this.sintegrastatus,
				cidadeData: this.cidadeData,
				estadosData: this.estadosData,
				datapagamento: this.datapagamento,
				datapagamentocheck: this.datapagamentocheck,
				situation: this.situation,
				situationcheckbox: this.situationcheckbox,
				status: this.status,
				searchTerm: this.searchTerm.replace('.', '').replace('-', '').replace('/', ''),
				motStatusInput: this.motStatusInput,
				motStatuscheckbox: this.motStatuscheckbox,
				statuscheckbox: this.statuscheckbox,
				sintegrastatusInput: this.sintegrastatusInput,
				sintegrastatuscheckbox: this.sintegrastatuscheckbox,
				motStatusData: this.motStatusData,
				cidadescheckbox: this.cidadescheckbox,
				cidadesinput: this.cidadesinput,
				estadosCheckbox: this.estadosCheckbox,
				estadosInput: this.estadosInput,
				orderby: this.orderby,
				direction: this.direction,
			};
			localStorage.setItem('filters-precadastro', JSON.stringify(filterStore));
			const offset = this.pagenumber * this.rowsperpagechange - this.rowsperpagechange;
			this.checkedRows = [];
			this.$emit('filter-apply', {
				limit: this.rowsperpage,
				offset,
				pagenumber: this.pagenumber,
			});
		},
		archiveModal(motivo) {
			if (this.archivedata) {
				this.archivedata.motivo = motivo;
				this.$emit('context-menu-action', this.archivedata);
				this.checkedRows = [];
				this.showModalArquivar = false;
			}
		},
		verifystatus(data) {
			if (data.selected.situacao === 0) {
				this.$emit('context-menu-action', data);
				this.checkedRows = [];
			}
		},
		archive(id) {
			this.archivedata = {};
			this.showModalArquivar = true;
			this.archivedata = {
				id,
				motivo: 2,
			};
			this.checkedRows = [];
		},
		async getAllMotStatus() {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC + api.env.EC_MOTIVO_STATUS}`;
				const request = await ecAxios.connection().get(`${url}`);
				const { data } = request;

				if (data.error !== 1) {
					data.motstatus.forEach((el) => {
						delete Object.assign(el, { label: el.descricao }).descricao;
					});
					this.motStatusOptions = data.motstatus;
				} else {
					// eslint-disable-next-line no-throw-literal
					throw { message: data.message };
				}
			} catch (e) {
				// eslint-disable-next-line no-console
				console.error(e.error || e);
			}
		},
		async getDistritos() {
			const newcidade = [];
			const newEstado = [];
			await ecAxios
				.connection()
				.get(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_CIDADES}`)
				.then((response) => {
					if (response.status === 200) {
						response.data.forEach((cidade) => {
							newcidade.push({
								id: cidade.cidade,
								label: cidade.cidade,
							});
						});

						this.cidades = newcidade;
					}
				})
				.catch(() => {});
			await ecAxios
				.connection()
				.get(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_ESTADOS}`)
				.then((response) => {
					if (response.status === 200) {
						response.data.forEach((estado) => {
							newEstado.push({
								id: estado.uf,
								label: estado.uf,
							});
						});

						this.estados = newEstado;
					}
				})
				.catch(() => {});
		},

		unarchive(id) {
			this.$emit('context-menu-action', { unarchive: true, id: [id] });
			this.checkedRows = [];
		},
		verifyStatusRow(status) {
			if (status === 1) {
				return 'Ativo';
			}
			if (status === 0) {
				return 'Inativo';
			}
			if (status === 2) {
				return 'Arquivado';
			}
			return '~';
		},
		verifyClassStatus(situacao) {
			if (situacao === 1) {
				return 'disabled';
			}
			if (situacao === -1) {
				return 'disabled';
			}
			if (situacao === 0) {
				return 'enabled';
			}
			return 'disabled';
		},
		getSintegraStatus(data) {
			let { sintegrastatus, receitastatus } = data;
			const sintegraId = sintegrastatus;
			sintegrastatus = parseInt(sintegrastatus, 10);
			if (sintegrastatus === 1) {
				sintegrastatus = 'Liberado';
			} else if (sintegrastatus === 0 && sintegrastatus !== '') {
				sintegrastatus = 'Bloqueado';
			} else {
				sintegrastatus = '';
			}
			if (receitastatus !== '' && receitastatus !== null) {
				if (receitastatus !== null) {
					receitastatus = `${receitastatus} (RF)`;
				}
				if (sintegrastatus) {
					sintegrastatus = `${`${sintegrastatus} / ${receitastatus}`}`;
				} else {
					sintegrastatus = receitastatus;
				}
			}
			return { sintegrastatus, sintegraId };
		},
	},
};
</script>
<style lang="scss" scoped>
.v-context {
	overflow-y: unset !important;
}
.box {
	overflow-y: scroll !important;
	overflow-x: hidden;
	max-height: 450px;
}
.icon-close {
	background-color: #eb4b4bdc;
	padding: 5px;
	border-radius: 2px;
	color: #fff;
	margin-left: 10px;
	cursor: pointer;
}
.row-item {
	width: 100%;
	margin-top: 5px;
	margin-bottom: 5px;
	display: flex;
	align-items: center;
	background-color: #f5f5f5;
	border-radius: 4px;
	color: #fff;
	display: inline-flex;
	height: 3em;
	justify-content: space-between;
	line-height: 1.5;
	padding: 0.75em !important;
}

.active {
	background-color: rgba(40, 199, 111, 0.12);
	color: #28c76f !important;
}
.inactive {
	background-color: rgba(255, 159, 67, 0.12);
	color: #ff9f43 !important;
}

.menu-row-option:hover {
	color: #25213b !important;
	border-radius: 5px;
}

.menu-row-option:hover .danger {
	color: #dc3545 !important;
}

.menu-row-option:hover .check {
	color: #007f00;
}

.menu-row-option:hover .archive {
	color: #f77f00;
}

.actions-table:hover {
	color: #25213b !important;
	border-radius: 5px;
}

.actions-table:hover .danger {
	color: #dc3545 !important;
}

.actions-table:hover .check {
	color: #007f00;
}

.actions-table:hover .archive {
	color: #f77f00;
}

.menu-row-option {
	display: flex;
	align-items: center;
	padding: 10px;
	width: 100%;
	height: 100%;
	cursor: pointer;
}

.row-item-text {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.75rem;
	text-align: right;
}
.container-precadastro {
	display: flex;
	width: 100%;
	flex-direction: column;
	background-color: #fff;
	padding-bottom: 10px;
	border-radius: 5px;
}
.actions-table .menu-row-icon {
	padding-right: unset;
}
.actions-table {
	cursor: pointer;
	align-items: center;
	justify-content: center;
	display: flex;
	margin-right: 10px;
	padding-top: 4px;
	padding-bottom: 4px;
	padding-right: 7px;
	padding-left: 7px;
	font-size: 12px;
	line-height: 1.5;
	border-radius: 0.25rem;
	border: 1px solid #e2e2e2;
}
.layout-table {
	cursor: pointer;
	align-items: center;
	justify-content: center;
	display: flex;
	margin-right: 10px;
	padding-left: 10px;
	padding-top: 5px;
	padding-bottom: 5px;
	padding-right: 10px;
	font-size: 0.8125rem;
	line-height: 1.5;
	border-radius: 0.25rem;
	border: 1px solid #e2e2e2;
}
.layout-icon {
	color: #8b83ba;
	cursor: pointer;
	margin-left: 5px;
}
.layout-icon .check {
	color: #069c2b;
	cursor: pointer;
	margin-left: 5px;
}
.search-container {
	width: 60%;
	display: flex;
	align-items: center;
}
.animation-refresh {
	-webkit-animation: rotating 2s linear infinite;
	-moz-animation: rotating 2s linear infinite;
	-ms-animation: rotating 2s linear infinite;
	-o-animation: rotating 2s linear infinite;
	animation: rotating 2s linear infinite;
}

@keyframes rotating {
	from {
		-ms-transform: rotate(0deg);
		-moz-transform: rotate(0deg);
		-webkit-transform: rotate(0deg);
		-o-transform: rotate(0deg);
		transform: rotate(0deg);
	}
	to {
		-ms-transform: rotate(360deg);
		-moz-transform: rotate(360deg);
		-webkit-transform: rotate(360deg);
		-o-transform: rotate(360deg);
		transform: rotate(360deg);
	}
}
.refreshtable {
	display: flex;
	margin-right: 20px;
	color: #00c9a7;
	cursor: pointer;
}

.enabled {
	border: unset;
}
.disabled {
	cursor: not-allowed !important;
}
.dropdown-menu {
	font-size: 12px !important;
}
.circle {
	width: 4px;
	height: 4px;
	margin: 1px;
	border-radius: 50%;
	background-color: rgb(212, 212, 212);
	transition: ease-in-out 0.5s;
}
.row-actions-circles {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 10px;
}
.row-actions-circles:hover {
	cursor: pointer;
}
.row-actions-circles:hover .circle {
	background-color: rgb(139, 139, 139);
}

/** Expandended Box */

/* .animate__animated.animate__bounceInRight:last-child {
  --animate-duration: 2s;
} */
.animate__animated.animate__bounceInRight:nth-child(1) {
	--animate-duration: 1s;
}
.animate__animated.animate__bounceInRight:nth-child(2) {
	--animate-duration: 1.5s;
}
.animate__animated.animate__bounceInRight:nth-child(3) {
	--animate-duration: 2s;
}
.animate__animated.animate__bounceInRight:nth-child(4) {
	--animate-duration: 2.5s;
}
.box-socios {
	width: 47%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px;
	height: 255px;
	background-color: #6d5bd027;
	border: 2px solid #6d5bd027;
	margin: 10px;
	transition: 300ms ease-in;
}
.box-container-image img {
	width: 180px;
}

.box-container-image-empresa {
	width: 200px;
}

.box-socios:hover {
	transform: scale(1.05);
}
.label-data {
	font-size: 12px;
	font-weight: bold;
	color: #241f41;
}

.title-name {
	padding-top: 5px;
	padding-bottom: 5px;
	font-size: 12px;
	font-weight: 500;
	color: #241f41;
}
.title-cpf {
	color: #241f41;
	font-size: 12px;
	padding-top: 2px;
	padding-bottom: 5px;
}
.box-title {
	color: #241f41;
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 10px;
	display: flex;
	align-items: center;
}
.icon-title {
	margin-right: 5px;
}
.icon-title-empresa {
	all: unset;
	color: #6d5bd000;
}

/** Fim expanded Box */
.row-text {
	color: $row-color;
	font-size: $row-size;
	font-weight: $row-weight;
}
.header-table {
	display: flex;
	background-color: #fff;
	padding: 20px;
	justify-content: space-between;
}
.box-empresa {
	width: 47%;
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px;
	height: 255px;
	background-color: #6d5bd027;
	border: 2px solid #6d5bd027;
	margin: 10px;
	transition: 300ms ease-in;
}
.box-details {
	width: 100%;
	box-sizing: border-box;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px;
	height: 210px;
	background-color: #ffffff;
	border: 2px solid #5e5e5e27;
	transition: 300ms ease-in;
}

.container-detail {
	display: flex;
	width: 100%;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
	flex-direction: row;
}
.container-double-box {
	display: flex;
	width: 100%;
	justify-content: space-between;
}
.situation-pagamento-box {
	border-bottom: 1px solid #6d5bd027;
	width: 100%;
	padding-bottom: 10px;
	padding-top: 10px;
}
.situation-pagamento-box:last-child {
	padding: 15px 15px 15px 0;
}
.situation-pedido-box {
	padding: 10px 15px 10px 0;
	border-bottom: 1px solid #6d5bd027;
	width: 100%;
	margin-bottom: 10px;
}
.grouped-situation-pagamento-input {
	display: flex;
	width: 100%;
	align-items: center;
	margin-left: 4px;
}
.grouped-situation-pedido-input {
	display: flex;
	width: 100%;
	align-items: center;
	margin-left: 4px;
}
.checkbox-situation {
	padding: 15px 15px 0px 0;
	width: 100%;
}
.select-pagamento-situation {
	display: flex;
	width: 100%;
}
.select-ped-situation {
	display: flex;
	width: 100%;
}
.situation-box {
	padding: 15px 15px 15px 0;
	border-bottom: 1px solid #6d5bd027;
	width: 100%;
	margin-bottom: 10px;
}
.input-date-picker {
	width: 50%;
}
.input-date-picker:first-child {
	margin-right: 4px;
	margin-left: 4px;
}
.grouped-situation-input {
	display: flex;
	width: 89%;
	justify-content: space-between;
}
.situation-box-input {
	align-items: center;
	display: flex;
	margin-top: 7px;
}
.exapanded-box {
	width: 30%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: row;
	border: 1px solid #6d5bd042;
	border-radius: 5px;
	padding: 10px;
}
.arrow-indicator {
	color: #6d5bd0;
}
.exapanded-box h1 {
	padding: 5px;
	color: rgb(0, 0, 0);
}
.exapanded-box h1:last-child {
	font-size: 12px;
}
.icon-expanded-box {
	font-size: 25px;
	padding: 5px;
	margin-right: 15px;
}

/** Context Menu */

.menu-row-icon {
	color: #8b83ba;
	padding-left: 10px;
	padding-right: 10px;
	font-weight: 500;
}

.menu-row-box-bottom {
	padding-top: 10px;
}
.menu-row-box {
	padding-bottom: 10px;
	border-bottom: 1px solid #f2f0f9;
}
.menu-row-option:first-child {
	margin-top: 5px;
}
.menu-row-option:hover {
	color: #25213b !important;
	border-radius: 5px;
}

.menu-row-option:hover .danger {
	color: #dc3545 !important;
}

.menu-row-option:hover .check {
	color: #007f00;
}

.menu-row-option:hover .archive {
	color: #f77f00;
}

.menu-row-option {
	display: flex;
	align-items: center;
	margin-left: 5px;
	margin-right: 5px;
	padding: 10px;

	cursor: pointer;
}
.select-container {
	all: unset;
	display: flex;
	border-radius: 0.25rem;
	cursor: pointer;
	border: 1px solid #e2e2e2;
	padding-top: 8px;
	padding-bottom: 8px;
	padding-left: 15px;
	padding-right: 15px;
	font-size: 12px;
	color: rgb(98, 98, 98);
}
.right-container {
	display: flex;
}
</style>

